'use client';

import { createContext, ReactNode, useMemo } from 'react';
import { create, StoreApi, UseBoundStore } from 'zustand';
import { MiniBannerVariant } from './types';

type ContextValue = {
    variant: `${MiniBannerVariant}`;
    useStore: UseBoundStore<StoreApi<{ slidesInView: number[] }>>;
};

export const MiniBannersContext = createContext<ContextValue>({} as ContextValue);

type Props = {
    variant: ContextValue['variant'];
    children?: ReactNode;
};
export const MiniBannersContextProvider = ({ variant, children }: Props) => {
    const useStore: ContextValue['useStore'] = useMemo(
        () =>
            create(() => ({
                slidesInView: [],
            })),
        [],
    );
    return (
        <MiniBannersContext.Provider value={{ useStore, variant }}>{children}</MiniBannersContext.Provider>
    );
};
